//Zur Wiederverwendung im Rahmen der USignal-Administration
export enum USignalActions {}
